import { IUser } from '../interfaces/user.interface';

export class User implements IUser {
  id = '';
  name = '';
  role = '';
  img = '';
  email = '';
}
